import type { FC } from 'react';

import { Illustration, IllustrationProps } from '../IllustrationWrapper';

export const Smile: FC<IllustrationProps> = ({ size, color }) => (
  <Illustration size={size} color={color}>
    <path d="m40,4.02C20.12,4.02,4,20.14,4,40.02s16.12,36,36,36,36-16.12,36-36S59.88,4.02,40,4.02Zm0,69c-18.2,0-33-14.8-33-33S21.8,7.02,40,7.02s33,14.8,33,33-14.8,33-33,33Zm-10-40.05c1.64,0,2.98-1.33,2.98-2.98s-1.33-2.98-2.98-2.98-2.98,1.33-2.98,2.98,1.33,2.98,2.98,2.98Zm20-5.95c-1.64,0-2.98,1.33-2.98,2.98s1.33,2.98,2.98,2.98,2.98-1.33,2.98-2.98-1.33-2.98-2.98-2.98Zm.35,22.43c-2.65,2.9-6.42,4.57-10.35,4.57s-7.73-1.68-10.38-4.61c-.56-.61-1.51-.66-2.12-.1-.61.56-.66,1.5-.11,2.12,3.22,3.55,7.81,5.59,12.61,5.59s9.35-2.02,12.56-5.55c.56-.61.51-1.56-.1-2.12-.61-.56-1.56-.52-2.12.1Z" />{' '}
  </Illustration>
);
